import { Component, OnInit, Input } from '@angular/core';
import { BreadCrumbItem } from '../breadcrumb.component';
import { MTTcomponents } from '../../../../Globals';
import { Router } from '@angular/router';

@Component({
  selector: 'app-breadcrumbroute',
  templateUrl: './breadcrumbroute.component.html',
  styleUrls: ['./breadcrumbroute.component.scss']
})
export class BreadcrumbrouteComponent implements OnInit {

  
  @Input() CurrnetComponentName: string;
  @Input () IsLastOne: boolean
  CurrentComponent: BreadCrumbItem
  constructor(private router: Router) { }

  ngOnInit() {
    this.CurrentComponent = MTTcomponents.find(x => x.ComponentName.toLocaleLowerCase().trim() === this.CurrnetComponentName.toLocaleLowerCase().trim());
  }

  // Click() {
  //   if(this.CurrentComponent.HasRoute){
  //     this.router.navigate(['/' + this.CurrentComponent.Route]);
  //   }
  // }
}
